import { ReactNode } from "react";
import { LinkProps, NavLink, Link } from "react-router-dom";

/**
 * The idea is to abstract the platform specific links and handle them from one
 * place.
 */


type LinkType = {
	href: string;
	children: ReactNode;
}

// Define a new type that merges props from NavLinkProps and LinkProps
type UnifiedNavLinkProps = LinkType & Omit<LinkProps, 'to'>;
type UnifiedLinkProps = LinkType & Omit<LinkProps, 'to'>;


/**
 * @param href
 * @param children
 * @param props
 * @constructor
 */
export const NavigationLink = ({ href, children, ...props }: { href: string, children: ReactNode } & UnifiedNavLinkProps) => {
	return <NavLink {...props} to={href}>{children}</NavLink>;
}

/**
 * @param href
 * @param children
 * @param props
 * @constructor
 */
export const AbstractLink = ({ href, children, ...props }: { href: string, children: ReactNode } & UnifiedLinkProps) => {
	return <Link {...props} to={href}>{children}</Link>;
}